import { render } from "./GrSectionWhy.vue?vue&type=template&id=d8c680c6"
import script from "./GrSectionWhy.vue?vue&type=script&lang=js"
export * from "./GrSectionWhy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__